import { useState, useEffect } from 'react';
import {
  getSentEmailLogs,
  IEmailLogDTO,
  IEmailLogContentDTO,
  IEmailLogPayload,
  IEmailInboxRecordsDTO,
} from 'wisestep-api';

export interface InboxEmailLogsType {
  lastIndexRead: number;
  totalCount: number;
  records: IEmailInboxRecordsDTO[];
}
export interface SentEmailLogsType {
  list: IEmailLogContentDTO[];
  totalCount: number;
  failed: number;
  sent: number;
}

const useFetchEmailLogs = (pageNo?: number, campaignCode?: string | null, filter?: string) => {
  const [sentEmailList, setSentEmailList] = useState<IEmailLogContentDTO[]>([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);
  const [sentCount, setSentCount] = useState(0);

  useEffect(() => {
    const fetchEmailLogs = async () => {
      if (campaignCode) {
        const payload: IEmailLogPayload = {
          campaignCode: campaignCode,
          page: pageNo,
          size: 20,
        };
        const res = await getSentEmailLogs(payload);
        const logs: IEmailLogDTO = res.data;
        setPagesCount(Number(logs?.total));
        setSentEmailList(logs?.searchResult?.content ?? []);
        setSentCount(Number(logs?.aggregationResult?.Sent?.true ?? 0));
        setFailedCount(Number(logs?.aggregationResult?.Error?.true ?? 0));
      } else {
        const payload: IEmailLogPayload = { page: pageNo, size: 20, filter: filter };
        const response = await getSentEmailLogs(payload);
        const logs: IEmailLogDTO = response.data;
        setPagesCount(Number(logs.total));
        setSentEmailList(logs?.searchResult?.content ?? []);
        setSentCount(Number(logs.aggregationResult?.Sent?.true ?? 0));
        setFailedCount(Number(logs.aggregationResult?.Error?.true ?? 0));
      }
    };
    fetchEmailLogs();
  }, [filter, campaignCode, pageNo]);

  const searchResult: SentEmailLogsType = {
    list: sentEmailList,
    totalCount: pagesCount,
    failed: failedCount,
    sent: sentCount,
  };
  return searchResult;
};
export default useFetchEmailLogs;
